<template>
  <div class="coupon">
    <baseSearch :list="searchFrom" @search="searchFun" @reset="resetFun"> </baseSearch>
    <div class="base_content mt15">
      <baseTable
        :loading="search.loading"
        :total="search.total"
        :page="search.post.page"
        :pagesize="search.post.limit"
        :list="search.table"
        :tableList="search.tableForm"
        @changePage="changePage"
        @handleSizeChange="handleSizeChange"
      >
        <!-- 商品 -->
        <template #info="scope">
          <div class="commidy_box">
            <img :src="scope.row.goods_image || require('@/static/img/empty_img.png')" alt="" />
            <div class="info_box">
              <div class="ellipsis2">{{ scope.row.goods_name }}</div>
              <div class="sku">
                {{ scope.row.spec_type == 10 ? "单规格" : "多规格" }}
              </div>
            </div>
          </div>
        </template>

        <!-- 是否参与 -->
        <template #is_join="scope">
          <span :style="{ color: scope.row.poolprofit_status == 1 ? '#006aff' : '#999' }">
            {{ scope.row.poolprofit_status == 1 ? "参与" : "未参与" }}
          </span>
        </template>

        <!-- 操作 -->
        <template #action="scope">
          <div
            @click="setJoin(scope.row)"
            class="but_primary"
          >
            {{ scope.row.poolprofit_status == 1 ? "不参与" : "参与" }}
          </div>
        </template>
      </baseTable>
    </div>
  </div>
</template>

<script>
import { eltips } from "@/util/util.js";
import baseSearch from "@/components/common/baseSearch.vue";
import baseTable from "@/components/common/baseTable.vue";

export default {
  components: {
    baseSearch,
    baseTable,
  },
  data() {
    return {
      search: {
        post: {
          page: 1,
          limit: 15,
          search: "",
          poolprofit_status: "",
          goods_type: "",
        },
        loading: false,
        total: 0,
        tableForm: [
          { label: "商品", prop: "info", width: 320 },
          { label: "价格", prop: "goods_price_min" },
          { label: "返现", prop: "return_price" },
          { label: "库存", prop: "stock_total" },
          { label: "销量", prop: "goods_sales" },
          { label: "是否参与", prop: "is_join" },
          { label: "操作", prop: "action", width: 120 },
        ],
        table: [],
      },
      searchFrom: [
        {
          type: "input",
          Field: "search",
          label: "商品名称/编码",
          style: { width: "180px" },
          placeholder: "请输入商品名称或编码",
        },
        {
          type: "select",
          Field: "poolprofit_status",
          label: "分红状态",
          style: { width: "140px" },
          options: [
            { label: "全部", value: "" },
            { label: "参与", value: "1" },
            { label: "不参与", value: "0" },
          ],
        },
        {
          type: "select",
          Field: "goods_type",
          label: "商品类型",
          style: { width: "150px" },
          options: [
            { label: "全部", value: "" },
            { label: "实物", value: "physical" },
            { label: "虚拟", value: "virtual" },
            { label: "虚拟卡密", value: "virtual_group" },
            { label: "定金预售", value: "deposit" },
          ],
        },
      ],
    };
  },
  created() {
    this.getTableData();
  },
  methods: {
    // 页码切换
    changePage(e) {
      this.search.post.page = e;
      this.getTableData();
    },
    // 每页条数切换
    handleSizeChange(e) {
      this.search.post.page = 1;
      this.search.post.limit = e;
      this.getTableData();
    },
    // 搜索
    searchFun(e) {
      this.search.post.page = 1;
      this.search.post = { ...this.search.post, ...e };
      this.getTableData();
    },
    // 重置
    resetFun() {
      this.search.post = {
        page: 1,
        limit: 15,
        search: "",
        poolprofit_status: "",
        goods_type: "",
      };
      this.getTableData();
    },
    // 获取分红商品列表
    getTableData() {
      this.search.loading = true;
      this.axios
        .get("/api/weishop/admin/plugin/poolprofit/goods/index", {
          params: this.search.post,
        })
        .then((res) => {
          if (res && (res.code === 0 || res.code === 200)) {
            this.search.table = res.data.data || [];
            this.search.total = res.data.total || 0;
          } else {
            eltips((res && res.msg) || "获取列表失败", "error");
          }
          this.search.loading = false;
        })
        .catch(() => {
          this.search.loading = false;
          eltips("获取列表失败", "error");
        });
    },
    // 参与/不参与
    setJoin(e) {
      let nextStatus = e.poolprofit_status == 1 ? 0 : 1;
      this.$confirmDialog({
        title: "提示",
        content: `<div style="font-size:16px;display:flex;align-items:center;justify-content:center;">是否设置该商品${nextStatus == 1 ? "参与" : "不参与"}分红?</div>`,
        cancelText: "取消",
        confirmText: "确定",
        showClose: true,
        success: (res) => {
          if (res.confirm) {
            this.axios
              .post("/api/weishop/admin/plugin/poolprofit/goods/status/" + e.goods_id, {
                poolprofit_status: nextStatus,
              })
              .then((res) => {
                if (res && (res.code === 0 || res.code === 200)) {
                  this.$set(e, "poolprofit_status", nextStatus);
                  eltips(res.msg, "success");
                  this.getTableData();
                } else {
                  eltips((res && res.msg) || "操作失败", "error");
                }
              })
              .catch(() => {
                eltips("操作失败", "error");
              });
          }
        },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.mt15 {
  margin-top: 15px;
}
.but_primary {
  color: #006aff;
  cursor: pointer;
  font-size: 13px;
}
.commidy_box {
  display: flex;
  align-items: center;
  img {
    width: 60px;
    height: 60px;
    object-fit: cover;
    border-radius: 4px;
  }
}
.info_box {
  margin-left: 10px;
  text-align: left;
  flex: 1;
  .ellipsis2 {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    line-height: 1.4;
  }
}
.sku {
  display: inline-flex;
  margin-top: 5px;
  background: #d1e7fe;
  border: 1px solid #d1e7fe;
  color: #006aff;
  font-size: 12px;
  height: 20px;
  line-height: 19px;
  padding: 0 4px;
  border-radius: 2px;
  width: fit-content;
}
</style>
